import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="cta-title">
      <div className="max-w-[1400px] mx-auto text-center">
        <h2
          id="cta-title"
          className="text-3xl md:text-5xl font-heading text-foreground-950"
        >
          准备好开启你的
          <br />
          漫画之旅了吗？
        </h2>
        <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-xl mx-auto">
          海量正版漫画免费看，每日更新不间断。现在就加入虫虫漫画，发现更多精彩作品！
        </p>
        <div className="mt-8">
          <Link
            to="/category/xuanhuan"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-medium text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            免费开始阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10 opacity-40">
          {['斗罗大陆', '一人之下', '狐妖小红娘', '全职高手', '镖人', '秦时明月'].map((name) => (
            <span key={name} className="text-sm text-foreground-600 whitespace-nowrap">
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}